import {createContext, useContext} from 'react'
import type {DeviceConfig} from '../components/types'

export interface EditorConfigContextValue {
  /** Full config of the currently active device — used for non-editable materials */
  deviceConfig: DeviceConfig
  /** The initial default device config (used for creating blank new scenes) */
  defaultDeviceConfig: DeviceConfig
  /** Update the active device config (called when user switches devices) */
  setDeviceConfig: (config: DeviceConfig) => void
}

export const EditorConfigContext = createContext<EditorConfigContextValue | null>(null)

/** Access the editor config context — must be used inside EditorConfigProvider */
export const useEditorConfig = (): EditorConfigContextValue => {
  const ctx = useContext(EditorConfigContext)
  if (!ctx) throw new Error('useEditorConfig must be used inside EditorConfigProvider')
  return ctx
}
